import React from 'react';
import { Form, Input, InputNumber, DatePicker, Radio, Select, Space } from 'antd';
import { ENTITY_REQUEST_ANSWER_TYPES } from '../../types/entity_add_requests';

const { TextArea } = Input;

interface EntityRequestAnswerFieldsProps {
	questions: any[];
}

// Renders the approver-configured questions as answer inputs. Meant to be placed inside a
// parent AntD <Form>; each answer is stored under the nested `answers[orderingId]` path so the
// parent can rebuild the { question, answer, orderingId } shape on submit.
const EntityRequestAnswerFields: React.FC<EntityRequestAnswerFieldsProps> = ({ questions }) => {
	if (!questions || questions.length === 0) {
		return null;
	}

	const getAnswerInput = (question) => {
		const options = question.options || [];
		switch (question.answerType) {
			case ENTITY_REQUEST_ANSWER_TYPES.long_text:
				return <TextArea autoSize={{ minRows: 2 }} />;
			case ENTITY_REQUEST_ANSWER_TYPES.number:
				return <InputNumber style={{ width: '100%' }} />;
			case ENTITY_REQUEST_ANSWER_TYPES.date:
				return <DatePicker style={{ width: '100%' }} format="MM-DD-YYYY" />;
			case ENTITY_REQUEST_ANSWER_TYPES.yes_no:
				return (
					<Radio.Group>
						<Radio value={true}>Yes</Radio>
						<Radio value={false}>No</Radio>
					</Radio.Group>
				);
			case ENTITY_REQUEST_ANSWER_TYPES.multiple_choice:
				return options.length > 8 ? (
					<Select placeholder="Select an option">
						{options.map((option, index) => (
							<Select.Option key={index} value={option}>
								{option}
							</Select.Option>
						))}
					</Select>
				) : (
					<Radio.Group>
						<Space direction="vertical">
							{options.map((option, index) => (
								<Radio value={option} key={index}>
									{option}
								</Radio>
							))}
						</Space>
					</Radio.Group>
				);
			case ENTITY_REQUEST_ANSWER_TYPES.short_text:
			default:
				return <Input />;
		}
	};

	return (
		<>
			{questions.map((question) => (
				<Form.Item
					key={question.orderingId}
					label={question.questionText}
					name={['answers', String(question.orderingId)]}
					rules={question.required ? [{ required: true, message: 'This field is required.' }] : []}
				>
					{getAnswerInput(question)}
				</Form.Item>
			))}
		</>
	);
};

export default EntityRequestAnswerFields;
